import { TranslationKey } from "../translations/TranslationKey";
import { CourseType } from "./Course";
import { TranslatedValue } from "./Shared/TranslatedValue";

export enum ExamStatus {
  Draft = "Draft",
  Published = "Published",
  Archived = "Archived",
}

export enum ExamType {
  Written = "Written",
  Oral = "Oral",
  TermPaper = "TermPaper",
}

export interface ExamTemplateIndex {
  id: string;
  name: TranslatedValue;
  examId?: string;
  price: number;
  type: ExamType;
  status: ExamStatus;
}

export interface ExamTemplateWithStructureIndex {
  id: string;
  courseTypes: CourseType[];
  availableCourseTypes: CourseType[];
  type: ExamType;
  name: TranslatedValue;
  includedInCourses: TranslatedValue;
  includedInModules: TranslatedValue;
}

export interface ExamViewModel {
  id: string;
  nameDE: string;
  nameEN: string;
  nameFR: string;
  nameIT: string;
  examId?: string;
  examExpenses: number;
  correctionExpenses: number;
  expertExpenses: number;
  type: ExamType;
  status: ExamStatus;
}

export const ExamStateTranslationKey: {
  [examStatus in ExamStatus]: TranslationKey;
} = {
  [ExamStatus.Draft]: "common.status.draft",
  [ExamStatus.Published]: "common.status.published",
  [ExamStatus.Archived]: "common.status.archived",
};

export const ExamTypeTranslationKey: {
  [examTypeNew in ExamType]: TranslationKey;
} = {
  [ExamType.Written]: "exam.type.written",
  [ExamType.Oral]: "exam.type.oral",
  [ExamType.TermPaper]: "exam.type.termPaper",
};

export interface RequiredExam {
  isNameDEEmpty: boolean;
  isNameFREmpty: boolean;
  isNameENEmpty: boolean;
  isNameITEmpty: boolean;
}
